import React from 'react';
import cx from 'classnames';

import SectionHeader from '@marketing/components/section_header';

import CarnegieMellonLogo from './assets/carnegie_mellon_logo.png';
import ConcentricCircles from '../../assets/concentric_circles.svg';
import HarvardLogo from './assets/harvard_logo.png'
import HeartIcon from './assets/heart_icon.svg';
import OxfordLogo from './assets/oxford_logo.png';
import PennLogo from './assets/penn_logo.png';
import StanfordLogo from './assets/stanford_logo.png';
import TexasLogo from './assets/texas_logo.png';
import UCLALogo from './assets/ucla_logo.png';
import UMichLogo from './assets/umich_logo.png';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-l u-padding-V-xl" style={{ position: 'relative' }}>
      <div
        className={cx(
          marketingStyles.fullPageWidthContainerBreakout,
          marketingStyles.purpleGradientReverseBg
        )}
        style={{ bottom: 0, height: 900, position: 'absolute', zIndex: -3 }}
      />

      <div
        style={{
          bottom: 0,
          left: '50%',
          position: 'absolute',
          transform: 'translateX(-50%)',
          width: 1130,
          zIndex: -2
        }}
      >
        <img alt="" loading="lazy" src={ConcentricCircles} />
      </div>

      <SectionHeader
        reveal
        subtitle="Our Admissions experts walk you through the entire application process for Master's and PhD programs."
        supertitle="Magoosh support"
        supertitleIcon={HeartIcon}
        title="Comprehensive application support"
      />

      <div className={cx(styles.schoolLogosContainer, 'd-flex gap-l flex-wrap')}>
        <img alt="Harvard University logo" height="85px" loading="lazy" src={HarvardLogo} width="200px" />
        <img alt="Stanford logo" height="85px" loading="lazy" src={StanfordLogo} width="200px" />
        <img alt="University of Michigan logo" height="85px" loading="lazy" src={UMichLogo} width="200px" />
        <img alt="University of Oxford logo" height="85px" loading="lazy" src={OxfordLogo} width="200px" />
        <img alt="The University of Texas logo" height="85px" loading="lazy" src={TexasLogo} width="200px" />
        <img alt="University of Pennsylvania logo" height="85px" loading="lazy" src={PennLogo} width="200px" />
        <img alt="Carnegie Mellon University logo" height="85px" loading="lazy" src={CarnegieMellonLogo} width="200px" />
        <img alt="UCLA logo" height="85px" loading="lazy" src={UCLALogo} width="200px" />
      </div>
    </div>
  );
};
